export default class betoniHintaClass {
  constructor() {
    this.betoniHintaId = null;
    this.ownerAsiakasId = null;
    this.betoniHinnastoId = null;
    this.aikaFrom = null;
    this.aikaTo = null;
    this.isNopea = null;
    this.laatuId = null;
    this.laatuNimike = null;
    this.lujuusId = null;
    this.lujuusSelite = null;
    this.notkeusId = null;
    this.notkeusSelite = null;
    this.raeKokoId = null;
    this.raeKokoSelite = null;
    this.raeKokoShort = null;
    this.eur = 150;
  }

  get betoniHinta() {
    return this.eur;
  }

  get betoniHintaHash() {
    return this.betoniHinta;
  }

  static getBetoniLaatuHinnat = async (tarjousId, laatuId, aika, token) => {
    const requestOptionsData = {
      tarjousId: tarjousId,
      laatuId: laatuId,
      aika: aika,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptionsData),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tarjous/betoni/laatu/hinnat/get",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw Error("This failed");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw Error(error);
      });
    return response;
  };

  static getBetoniAttrHinnat = async (tarjousId, token) => {
    const requestOptionsData = {
      tarjousId: tarjousId,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptionsData),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tarjous/betoni/attr/hinnat/get",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw Error("This failed");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw Error(error);
      });
    return response;
  };

  static getBetoniHinta = async (betoni, tarjousId, tarjousAika, token) => {
    const requestOptionsData = {
      tarjousId: tarjousId,
      laatuId: betoni.laatu.laatuId,
      kayttoIkaId: betoni.kayttoIka.kayttoIkaId,
      lujuusId: betoni.lujuus.lujuusId,
      notkeusId: betoni.notkeus.notkeusId,
      raeKokoId: betoni.raeKoko.raeKokoId,
      rasitusLuokat: betoni.rasitus.rasitusluokat,
      isNopea: betoni.isNopea,
      attr: betoni.attr.attr,
      aika: tarjousAika,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptionsData),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tarjous/betoni/laatu/hinta/get",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw Error("This failed");
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        throw Error(error);
      });
    if (response.length > 0) return response[0].eur;
    else return null;
  };

  static saveBetoniAttrHintaToDB = async (
    tarjousId,
    attrId,
    eur,
    comment,
    keikkaBetoniAttrComment,
    token
  ) => {
    const requestOptionsData = {
      tarjousId: tarjousId,
      attrId: attrId,
      comment: comment,
      keikkaBetoniAttrComment: keikkaBetoniAttrComment,
      eur: eur.replace(",", "."),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptionsData),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tarjous/betoni/attr/hinta/set",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
    return response;
  };

  static saveBetoniLaatuHintaToDB = async (
    laatuId,
    tarjousId,
    lujuusId,
    raeKokoId,
    notkeusId,
    isNopea,
    kayttoIkaId,
    eur,
    token
  ) => {
    const requestOptionsData = {
      laatuId: laatuId,
      tarjousId: tarjousId,
      lujuusId: lujuusId,
      raeKokoId: raeKokoId,
      notkeusId: notkeusId,
      isNopea: isNopea,
      kayttoIkaId: kayttoIkaId,
      eur: eur.replace(",", "."),
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestOptionsData),
    };
    const response = await fetch(
      import.meta.env.VITE_SERVER_URL + "/api/tarjous/betoni/laatu/hinta/set",
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return false;
        }
        return true;
      })
      .catch(() => {
        return false;
      });
    return response;
  };
}
